export default __webpack_public_path__ + "static/media/planet2.7a7f1f4b.png";